interface AsideMenuItem {
  to: string
  icon: string
  title: string
  fontIcon: string
  ticketItemCount:number
}

const navs: Array<AsideMenuItem> = [
  {
    to: '/dashboard',
    icon: '/media/icons/duotune/general/home.svg',
    title: 'Dashboard',
    fontIcon: 'bi-app-indicator',
    ticketItemCount :0
  },
  {
    to: '/integration/product',
    icon: '/media/icons/duotune/ecommerce/boxes.svg',
    title: 'Ürün Entegrasyonu',
    fontIcon: 'bi-app-indicator',
    ticketItemCount :0
  },
  {
    to: '/integration/order',
    icon: '/media/icons/duotune/ecommerce/bag.svg',
    title: 'Sipariş Entegrasyonu',
    fontIcon: 'bi-app-indicator',
    ticketItemCount :0
  },
  {
    to: '/reports',
    icon: '/media/icons/duotune/files/file-search.svg',
    title: 'Raporlar',
    fontIcon: 'bi-app-indicator',
    ticketItemCount :0
  },
  {
    to: '/settings',
    icon: '/media/icons/duotune/coding/settings.svg',
    title: 'Ayarlar',
    fontIcon: 'bi-app-indicator',
    ticketItemCount :0
  },
  {
    to: '/tickets',
    icon: '/media/icons/duotune/communication/com012.svg',
    title: 'Ticket Destek',
    fontIcon: 'bi-app-indicator',
    ticketItemCount :0
  }
]

export default navs
